import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

type AppUploadButtonProps = {
  onUpload: any;
  isUploading: any;
  acceptFiles: string;
  title: string;
};

export default function AppUploadButton({
  onUpload,
  isUploading,
  acceptFiles,
  title,
  
}: AppUploadButtonProps) {
  const [file, setFile] = useState<any>(null);
  const { t } = useTranslation();
  const LocalBasePath = "page.audioUpload";
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const onDrop = useCallback(async (acceptedFiles) => {
    isUploading(true);
    setFile(acceptedFiles[0]);
    await onUpload(acceptedFiles[0]);

  }, []);
  const onDropRejected = useCallback(async (acceptedFiles) => {
    isUploading(false);
  }, []);

  const { getRootProps, getInputProps, isDragReject,fileRejections, } = useDropzone({
    onDrop,
    onDropRejected,
    accept: acceptFiles,
    maxSize: 5242880,
  });

  return (
    <div className="col-span-3">
      <button
        {...getRootProps({ className: "dropzone", })}
        type="button"
        className="ltr:ml-5 rtl:mr-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
      >
        {title}
        <input {...getInputProps()} />
      </button>
      {isDragReject && (
        <p className="mt-2 text-sm text-red-600">
          {t(`${LocalBasePath}.errorFile`)}
        </p>
      )}
      { fileRejections.length >0 && (
        <p className="mt-2 text-sm text-red-600">
          {t(`${LocalBasePath}.errorSizeFile`, { size: 5 })}
        </p>
      )}
    </div>
  );
}
